import { createStore } from 'vuex'
import api from '@/api/index'
import router from '@/router/index'
import { jwtDecrypt } from '@/utils/jwtDecrypt'
import { useCookies } from 'vue3-cookies'
import Swal from 'sweetalert2/dist/sweetalert2'

const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN'
const { cookies } = useCookies()

export default createStore({
  state: {
    accessToken: '',
    user: {
      login: 'failed',
      id: '',
      name: '',
      access: {
        token: '',
        exp: '',
      },
      auth: '',
      allowyn: '',
      allowmemo: ''
    },
  },
  getters: {
    getData(state) {
      return state.user
    },
  },
  mutations: {
    [SET_ACCESS_TOKEN](state, accessToken) {
      if (accessToken) {
        const decodedPayload = jwtDecrypt(accessToken)
        var moment = require('moment')
        const data = {
          login: 'success',
          id: decodedPayload.sub,
          name: decodedPayload.userNm,
          access: {
            token: accessToken,
            exp: new Date(moment.unix(decodedPayload.exp)).toUTCString(),
          },
          auth: decodedPayload.auth.split(','),
          accessToken: accessToken,
          allowyn: decodedPayload.allowYn,
          allowmemo: decodedPayload.allowMemo,
        }

        state.user = data
      }
    },
    resetData(state) {
      state.user = {
        login: 'failed',
        id: '',
        name: '',
        access: {
          token: '',
          exp: '',
        },
        auth: '',
        allowyn: '',
        allowmemo: ''
      }
    },
    saveLoginStatus(state, status) {
      state.user.login = status
    },
  },
  actions: {
    login({ commit }, payload) {
      const { id, pw } = payload
      return api.post('/api/auth', { id, pw }).then((res) => {
        const accessToken = res.headers['authorization']
        if(res.status === 204){
          Swal.fire({
          title: '알림',
          text: '아이디 및 비밀번호가 일치하지않습니다.',
          showConfirmButton: true,
          confirmButtonText: '확인',
          showCancelButton: false,
          allowOutsideClick: false,
          customClass: {
            title: 'fd',
            htmlContainer: 'f1',
            confirmButton: 'f2',
          },
        })
          }
        else if (accessToken) {
          commit(SET_ACCESS_TOKEN, accessToken)
            cookies.set('accessToken', accessToken, this.state.user.access.exp)
            router.push('/home')  
        }}).catch((err) => {
          const status = err.response?.status
          const msg = err.response?.data?.error || '알 수 없는 오류가 발생했습니다.'
          if (status === 409) {
            Swal.fire({
              title: '중복 로그인',
              text: msg, 
              confirmButtonText: '확인',
              allowOutsideClick: false,
            })
          }
          else if (status === 423) {
            Swal.fire({
              title: '알림',
              text: msg, 
              confirmButtonText: '확인',
              allowOutsideClick: false,
            })
          }
          else{
            Swal.fire({
              title: '알림',
              text: msg, 
              confirmButtonText: '확인',
              allowOutsideClick: false,
            })
          }
        })
    },
    async logout({ commit }) {
      await cookies.remove('accessToken')
      sessionStorage.clear()

      commit('resetData')
      commit('saveLoginStatus', 'failed')
      router.push({ name: 'Login' })
    },
    async loadTokenFromStorage({ commit }) {
      const token = await cookies.get('accessToken')
      if (token) commit('SET_ACCESS_TOKEN', token)
    },
  },
  modules: {},
})
